import {lazy} from "react";

export const EmployeesTableLazy = lazy(()=>import('./EmployeesTable'))